import React from 'react';
import { ArrowLeftIcon, ClockIcon, UserIcon } from 'lucide-react';
export function TaxCodeAuditHistory({
  taxCode,
  auditEntries,
  onBack,
  locale = 'en-US'
}) {
  return <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-10611">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-10612">
        <div className="flex justify-between items-center" data-id="element-10613">
          <div data-id="element-10614">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-10615">
              Audit History
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-10616">
              Tracking changes for tax code: {taxCode.code}
            </p>
          </div>
          <button onClick={onBack} className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-10617">
            <ArrowLeftIcon className="h-4 w-4 mr-1.5" data-id="element-10618" />
            Back to Tax Codes
          </button>
        </div>
      </div>
      <div className="border-t border-gray-200" data-id="element-10619">
        {auditEntries.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center text-gray-500" data-id="element-10620">
            No audit history available for this tax code.
          </div> : <div className="px-4 py-5 sm:p-6" data-id="element-10621">
            <div className="flow-root" data-id="element-10622">
              <ul className="-mb-8" data-id="element-10623">
                {auditEntries.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((entry, index) => <li key={entry.id} data-id="element-10624">
                      <div className="relative pb-8" data-id="element-10625">
                        {index !== auditEntries.length - 1 ? <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" data-id="element-10626"></span> : null}
                        <div className="relative flex space-x-3" data-id="element-10627">
                          <div data-id="element-10628">
                            <span className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center ring-8 ring-white" data-id="element-10629">
                              <ClockIcon className="h-5 w-5 text-indigo-600" data-id="element-10630" />
                            </span>
                          </div>
                          <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" data-id="element-10631">
                            <div data-id="element-10632">
                              <p className="text-sm text-gray-900" data-id="element-10633">
                                <span className="font-medium" data-id="element-10634">
                                  {entry.action}
                                </span>{' '}
                                field{' '}
                                <span className="font-medium" data-id="element-10635">
                                  {entry.field}
                                </span>
                              </p>
                              <div className="mt-2 flex items-center text-sm text-gray-500" data-id="element-10636">
                                <div className="bg-gray-100 rounded px-2 py-1 mr-2" data-id="element-10637">
                                  <span className="text-xs text-gray-800 font-mono" data-id="element-10638">
                                    {formatAuditValue(entry.oldValue)}
                                  </span>
                                </div>
                                <span className="mx-2" data-id="element-10639">→</span>
                                <div className="bg-green-100 rounded px-2 py-1" data-id="element-10640">
                                  <span className="text-xs text-green-800 font-mono" data-id="element-10641">
                                    {formatAuditValue(entry.newValue)}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="text-right text-sm whitespace-nowrap text-gray-500" data-id="element-10642">
                              <div className="flex items-center" data-id="element-10643">
                                <UserIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-10644" />
                                <span data-id="element-10645">{entry.userName}</span>
                              </div>
                              <time dateTime={entry.timestamp} data-id="element-10646">
                                {new Date(entry.timestamp).toLocaleString(locale)}
                              </time>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>)}
              </ul>
            </div>
          </div>}
      </div>
    </div>;
}
// Helper function to format audit values for display
function formatAuditValue(value) {
  if (value === 'true') return 'Yes';
  if (value === 'false') return 'No';
  if (value === '') return '(empty)';
  if (value === 'null' || value === 'undefined') return '(none)';
  return value;
}